<!-- Outer wrapper: applies React's dialog content styling -->
<div class="form-offline-wrapper px-7 pt-14 pb-6 md:px-10 md:pt-18">
  <!-- Header -->
  <div class="form-offline-header">
    <div class="d-flex justify-content-between align-items-start">
      <div>
        <h3 *ngIf="!edit" class="header-title">Cotización offline</h3>
        <h3 *ngIf="edit" class="header-title">Solicitud offline</h3>
      </div>
      <button type="button" class="btn-close-modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

    <!-- Tabs: React TabButton style -->
    <div *ngIf="!edit" class="tabs-container">
      <button
        class="btn-tab"
        [class.active]="tab === 'hotel'"
        (click)="tabActive('hotel')">
        HOTEL
        <span *ngIf="formHotelEdited" class="form-edit-indicator">
          <span>Carga de formulario</span>
          <span class="indicator-x" (click)="resetForm('hotel')">&#10005;</span>
        </span>
      </button>
      <button
        class="btn-tab"
        [class.active]="tab === 'transfer'"
        (click)="tabActive('transfer')">
        TRASLADO
        <span *ngIf="formTransferEdited" class="form-edit-indicator">
          <span>Carga de formulario</span>
          <span class="indicator-x" (click)="resetForm('transfer')">&#10005;</span>
        </span>
      </button>
      <button
        class="btn-tab"
        [class.active]="tab === 'rent-a-car'"
        (click)="tabActive('rent-a-car')">
        RENT A CAR
        <span *ngIf="formRentACarEdited" class="form-edit-indicator">
          <span>Carga de formulario</span>
          <span class="indicator-x" (click)="resetForm('rent-a-car')">&#10005;</span>
        </span>
      </button>
    </div>

    <!-- Edit mode header -->
    <div *ngIf="edit" class="d-flex flex-column my-3 edit-header">
      <h3 class="mb-0" *ngIf="editData.category === 'hotels'">Hotel</h3>
      <h3 class="mb-0" *ngIf="editData.category === 'transfers'">Traslado</h3>
      <h3 class="mb-0" *ngIf="editData.category === 'rentacar'">Rent a car</h3>
      <p class="mb-0">
        <span>Estado:</span>
        <span
              class="px-2 rounded-pill status-pill"
              [ngClass]="{'status-solicitada': editData.status === null || editData.status === 0, 'status-procesada': editData.status !== 0 && editData.status !== null}">
              {{editData.status === 0 || editData.status === null ? 'Solicitada' : 'Procesada'}}
        </span>
      </p>
      <p class="mb-0" *ngIf="editData.category === 'transfers'">
        <span>Traslado:</span>
        <span class="transfer-direction">
          {{editData.oneWay ? ' Solo ida' : ' Ida y vuelta'}}
        </span>
      </p>
    </div>

    <div [ngClass]="{'d-block': tab==='hotel', 'd-none': tab!='hotel' }">
      <form *ngIf=" tab==='hotel'"  [formGroup]="formHotel" class="d-flex flex-column">
        <!-- Form body wrapper -->
        <div class="form-body">
        <!-- Sección Cliente y tipo de solicitud -->
        <div class="d-flex flex-column mb-4 mt-2">
          <span class="section-title">Cliente y tipo de solicitud</span>

          <div class="row">
            <div class="col-4">
              <!-- Selector de file existente -->
              <select
                class="form-control field-input mb-2"
                [disabled]="edit || loadingFiles || showNewFileNameInput"
                [ngModel]="selectedFileId"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onExistingFileSelected($event)"
              >
                <option [ngValue]="null">
                  {{ loadingFiles ? 'Cargando files...' : 'File existente' }}
                </option>
                <option *ngFor="let f of existingFiles" [ngValue]="f.id">
                  {{ getFileLabel(f) }}
                </option>
              </select>

              <!-- Input Nombre File (solo se muestra si el usuario clickeó "+ Crear nuevo nombre de file") -->
              <ng-container *ngIf="showNewFileNameInput">
                <div class="d-flex align-items-center mb-2" style="gap: 0.5em;">
                  <input
                    type="text"
                    class="form-control"
                    id="fileName"
                    name="fileName"
                    placeholder="Nombre del nuevo file"
                    maxlength="50"
                    autocomplete="off"
                    formControlName="fileName"
                  />
                  <button
                    type="button"
                    class="btn"
                    (click)="cancelNewFileName()"
                    aria-label="Cancelar nuevo file"
                    style="border: 1px solid #ececec; background-color: #fcfcfc; cursor: pointer;
                           font-size: 16px; color: #999; width: 38px; height: 38px;
                           border-radius: 6px; line-height: 1; padding: 0; flex-shrink: 0;">
                    ×
                  </button>
                  <span *ngIf="formHotel.get('fileName')?.value?.length === 50" class="text-danger ml-2" style="font-size: 12px; font-weight: 600;"> Máximo 50 caracteres </span>
                </div>
              </ng-container>

              <!-- Botón para activar el input de nuevo nombre -->
              <div class="d-flex align-items-center" *ngIf="!edit && !showNewFileNameInput">
                <button
                  type="button"
                  class="btn btn-link p-0"
                  style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 500;
                         color: #000000; text-decoration: none; text-align: left;"
                  (click)="openNewFileNameInput()">
                  + Crear nuevo nombre de file
                </button>
              </div>
            </div>

            <div class="col-4">
              <label class="field-label">Cliente</label>
              <select
                class="form-control mb-2"
                id="clientSelect"
                name="clientSelect"
                class="form-control field-input"
                [disabled]="edit || !selectedFileId || showNewClientInput"
                [ngModel]="selectedClientId"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onClientSelectedFromFile($event)"
              >
                <option [ngValue]="null">
                  {{ !selectedFileId
                      ? 'Seleccioná un file'
                      : (getClientsForSelectedFile().length === 0
                          ? 'Sin clientes'
                          : 'Seleccionar cliente') }}
                </option>
                <option *ngFor="let c of getClientsForSelectedFile()" [ngValue]="c.id">
                  {{ getClientLabel(c) }}
                </option>
              </select>

              <!-- Botón para activar el input de nuevo cliente -->
              <div class="d-flex align-items-center" *ngIf="!edit && !showNewClientInput && selectedFileId">
                <button
                  type="button"
                  class="btn btn-link p-0"
                  style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 500;
                         color: #000000; text-decoration: none; text-align: left;"
                  (click)="openNewClientInput()">
                  + Crear nuevo cliente
                </button>
              </div>
            </div>

            <div class="col-4">
              <label class="field-label">Tipo de solicitud</label>
              <select
                class="form-control"
                formControlName="requestType"
                [disabled]="edit"
                class="form-control field-input"
              >
                <option value="quotation">Cotización</option>
                <option value="reservation">Reserva</option>
              </select>
            </div>
          </div>

          <!-- Bloque Datos del cliente (solo visible cuando el usuario clickeó "+ Crear nuevo cliente") -->
          <div class="d-flex flex-column mt-3" formGroupName="client" *ngIf="showNewClientInput">

            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="mb-0"
                 style="font-family: 'Rubik', serif; font-weight: 600; font-size: 18px;">
                Datos del nuevo cliente
              </p>
              <button
                type="button"
                class="btn"
                (click)="cancelNewClient()"
                aria-label="Cancelar nuevo cliente"
                style="border: 1px solid #ececec; background-color: #fcfcfc; cursor: pointer;
                       font-size: 16px; color: #999; width: 38px; height: 38px;
                       border-radius: 6px; line-height: 1; padding: 0;">
                ×
              </button>
            </div>

            <!-- Nombre + Apellido -->
            <div class="d-flex mb-2" style="gap: 1em;">
              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientFirstName"
                       name="clientFirstName"
                       placeholder="Nombre"
                       [maxLength]="50"
                       [readonly]="edit"
                       (keydown)="blockInvalidKeys($event, 'name')"
                       formControlName="first_name" />
                <span *ngIf="formHotel.get('client.first_name')?.hasError('required') &&
                            formHotel.get('client.first_name')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Obligatorio
                </span>
              </div>

              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientLastName"
                       name="clientLastName"
                       placeholder="Apellido"
                       [maxLength]="50"
                       [readonly]="edit"
                       (keydown)="blockInvalidKeys($event, 'name')"
                       formControlName="last_name" />
              </div>
            </div>

            <!-- Título + Nombre + Apellido -->
            <div class="d-flex mb-2" style="gap: 1em;">
              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientFirstName"
                       name="clientFirstName"
                       placeholder="Nombre"
                       [maxLength]="50"
                       [readonly]="edit"
                       (keydown)="blockInvalidKeys($event, 'name')"
                       formControlName="first_name" />
                <span *ngIf="formHotel.get('client.first_name')?.hasError('required') &&
                            formHotel.get('client.first_name')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Obligatorio
                </span>
              </div>

              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientLastName"
                       name="clientLastName"
                       placeholder="Apellido"
                       [maxLength]="50"
                       [readonly]="edit"
                       (keydown)="blockInvalidKeys($event, 'name')"
                       formControlName="last_name" />
              </div>
            </div>

            <!-- Email -->
            <div class="d-flex mb-2" style="gap: 1em;">
              <div class="position-relative w-100">
                <input type="email"
                       class="form-control"
                       id="clientEmail"
                       name="clientEmail"
                       placeholder="E-mail"
                       [maxLength]="80"
                       [readonly]="edit"
                       formControlName="email" />
                <span *ngIf="formHotel.get('client.email')?.hasError('required') &&
                            formHotel.get('client.email')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Obligatorio
                </span>
                <span *ngIf="formHotel.get('client.email')?.hasError('email') &&
                            formHotel.get('client.email')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Email inválido
                </span>
              </div>
            </div>

            <!-- Phone code + Phone -->
            <div class="d-flex mb-2" style="gap: 1em;">
              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientPhoneCode"
                       name="clientPhoneCode"
                       placeholder="País + Cód. telefónico"
                       [readonly]="edit"
                       [matAutocomplete]="autoCountry"
                       autocomplete="off"
                       [value]="phoneCodeSelected || ''"
                       (input)="phoneCodeSelected = $any($event.target).value" />
                <mat-autocomplete
                  #autoCountry="matAutocomplete"
                  [displayWith]="displayCountryFn"
                  (optionSelected)="onCountrySelected($event.option.value)">
                  <mat-option *ngFor="let country of countriesData" [value]="country">
                    {{ country.country_name }} (+{{ country.phone_code }})
                  </mat-option>
                </mat-autocomplete>
                <span *ngIf="formHotel.get('client.phone_code')?.hasError('required') &&
                            formHotel.get('client.phone_code')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Obligatorio
                </span>
              </div>

              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientPhone"
                       name="clientPhone"
                       placeholder="N° Teléfono"
                       [maxLength]="20"
                       [readonly]="edit"
                       (keydown)="blockInvalidKeys($event, 'number')"
                       formControlName="phone" />
                <span *ngIf="formHotel.get('client.phone')?.hasError('required') &&
                            formHotel.get('client.phone')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Obligatorio
                </span>
                <span *ngIf="formHotel.get('client.phone')?.hasError('pattern') &&
                            formHotel.get('client.phone')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Mínimo 6 dígitos
                </span>
              </div>
            </div>
          </div>
          <!-- Fin Datos del cliente -->
        </div>
        <!-- Fin sección Cliente y tipo de solicitud -->

        <div class="d-flex flex-column mb-4 mt-2" >
          <p class="mb-1" class="section-title">Destino y fecha</p>
          <div class="d-flex align-items-center mb-2" style="gap: 1em;">
            <div class="position-relative" style="width: 70%">
              <input type="text"
                id="destination"
                name="destination"
                class="form-control"
                placeholder="Destino"
                [maxLength]="80"
                [minLength]="3"
                formControlName="destination"
                [matAutocomplete]="autoDestination"
                autocomplete="off">
              <mat-autocomplete
                #autoDestination="matAutocomplete"
                [displayWith]="displayDestinationFn"
                (optionSelected)="onDestinationSelected($event.option.value)">
                <ng-container *ngFor="let item of destinationOptions">
                  <ng-container *ngIf="item.type === 'city' && item.cities && item.cities.length > 0">
                    <mat-option disabled style="background-color: #f4f4f4; height: 42px">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center" style="gap: 0.25em">
                          <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px" />
                          <span class="mt-1"
                            style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important">Ubicación</span>
                        </div>
                        <div>
                          <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important">
                            {{ item.cities.length }} resultados
                          </span>
                        </div>
                      </div>
                    </mat-option>
                    <mat-option *ngFor="let city of item.cities" [value]="city">
                      <div class="d-flex align-items-center" style="gap: .75em; margin-left: 9px">
                        <img src="{{city?.country_logo}}" style="width: 16px; height: 16px; border-radius: 50%;" />
                        <p class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1">
                          {{ capitalize(city.city_name) }},
                          <span class="mb-0"
                            style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important">
                            {{ capitalize(city.city_province) }}{{ city.city_province ? "," : "" }}
                            {{ capitalize(city.country_name) }}
                          </span>
                        </p>
                      </div>
                    </mat-option>
                  </ng-container>
                </ng-container>
              </mat-autocomplete>
              <span *ngIf="formHotel.get('destination').hasError('required')"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
                Obligatorio
              </span>
              <span *ngIf="formHotel.get('destination').hasError('minlength') &&
                          formHotel.get('destination').touched"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
                Mínimo 3 caracteres
              </span>
              <span *ngIf="formHotel.get('destination').value?.length === 80"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
                Máximo 80 caracteres
              </span>
            </div>
            <div style="width: 30%; position:relative">
              <input type="text"
                #reservation_date
                readonly
                id="arrivalDepartureDate"
                name="arrivalDepartureDate"
                formControlName="arrivalDepartureDate"
                autocomplete="off"
                class="form-control input-ngxDateRangePicker"
                ngxDaterangepickerMd
                placeholder="Check-in - check-out"
                [locale]="{applyLabel: 'ok', format: 'DD/MM/YYYY'}"
                startKey="start"
                endKey="end"
                [autoApply]="true"
                [closeOnAutoApply]="true"
                [minDate]="minDate"
                [maxDate]="maxDate"
                (startDateChanged)="startDateClicked($event)"
                (endDateChanged)="endDateClicked($event)"
                [isInvalidDate]="isInvalidDate"
                (click)="fixCalendarPosition()"
                name="daterange"
                style="background-color: white;"
                [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': clientSetting?.clients_setting_global?.color_main_1},
                            ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': clientSetting?.clients_setting_global?.color_main_1}}"
                />
                <span *ngIf="
                            dateRange?.start === null && dateRange?.end === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
              >
                Obligatorio</span>
            </div>
          </div>
        </div>
        <!-- Input Nombre de hoteles -->
        <div class="row mb-4" style="gap: 0; position: relative;">
          <div class="col-12 position-relative" style="padding-right: 0.5em;">
            <input
              type="text"
              id="hotelsName"
              name="hotelsName"
              matInput
              class="form-control"
              placeholder="Nombre de hoteles"
              [maxLength]="100"
              formControlName="hotelsName"
              [matAutocomplete]="autoHotelsName"
              #hotelsNameTrigger="matAutocompleteTrigger"
              autocomplete="off"
            />
            <mat-autocomplete
              #autoHotelsName="matAutocomplete"
              [displayWith]="displayHotelsNameFn"
              (optionSelected)="onHotelsNameSelected($event.option.value)"
            >
              <ng-container *ngFor="let item of hotelsNameOptions">
                <ng-container *ngIf="item.type === 'hotel' && item.hotels && item.hotels.length > 0">
                  <mat-option disabled style="background-color: #f4f4f4; height: 42px">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center" style="gap: 0.25em">
                        <img src="../../../../assets/icons/search-box/hotel_gris.svg" style="width: 35px; height: 35px" />
                        <span class="mt-1"
                          style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important">Hotel</span>
                      </div>
                      <div>
                        <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important">
                          {{ item.hotels.length }} resultados
                        </span>
                      </div>
                    </div>
                  </mat-option>
                  <mat-option *ngFor="let hotel of item.hotels" [value]="hotel">
                    <div class="d-flex align-items-center" style="gap: .75em; margin-left: 9px">
                      <img src="{{hotel?.country_logo}}" style="width: 16px; height: 16px; border-radius: 50%;" />
                      <p class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1">
                        {{ capitalize(hotel.name) }},
                        <span class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important">
                          {{ capitalize(hotel.city_name) }}{{ hotel.city_name ? "," : "" }}
                          {{ capitalize(hotel.city_province) }}{{ hotel.city_province ? "," : "" }}
                          {{ capitalize(hotel.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </mat-autocomplete>
            <span *ngIf="formHotel.get('hotelsName').hasError('required') &&
                        formHotel.get('hotelsName').touched"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
              Obligatorio
            </span>
            <span *ngIf="formHotel.get('hotelsName').value?.length === 100"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
              Máximo 100 caracteres
            </span>
          </div>
        </div>

         <div class="d-flex">
            <!-- Input "Zonas de interés" removido: ya no aplica -->
        </div>

        <!-- Sección colapsable "Expandir tu búsqueda" -->
        <div class="d-flex flex-column mt-3" *ngIf="!edit">

          <!-- Estado colapsado: solo el botón "Expandir tu búsqueda" -->
          <div class="d-flex align-items-center justify-content-end"
               *ngIf="!hotelSuggestSectionOpen">
            <button type="button"
                    class="btn-expand-search"
                    (click)="openHotelSuggestSection()">
              <span class="expand-icon">+</span>
              Expandir tu búsqueda
            </button>
          </div>

          <!-- Estado expandido: input + botón Buscar + resultados -->
          <div *ngIf="hotelSuggestSectionOpen"
               class="expand-section d-flex flex-column mt-2">

            <!-- Header con título y X para colapsar -->
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="expand-header">
                Expandir tu búsqueda
              </span>
              <button type="button"
                      class="btn-close-modal"
                      style="width: 28px; height: 28px; font-size: 1rem;"
                      (click)="closeHotelSuggestSection()"
                      aria-label="Cerrar sección Expandir tu búsqueda">
                <span>&times;</span>
              </button>
            </div>

            <p class="mb-2 expand-hint">
              Si no encontraste el hotel en la lista, escribí su nombre y buscaremos en nuestra base extendida.
            </p>

            <!-- Input + botón Buscar -->
            <div class="d-flex align-items-center" style="gap: 0.5em;">
              <div class="position-relative flex-grow-1 w-100">
                <input type="text"
                       id="hotelSuggestSearchInput"
                       name="hotelSuggestSearchInput"
                       class="form-control"
                       placeholder="Nombre del hotel a buscar"
                       [maxLength]="100"
                       autocomplete="off"
                       [(ngModel)]="hotelSuggestSearchInput"
                       [ngModelOptions]="{standalone: true}"
                       (keydown.enter)="runHotelSuggestSearch()" />
              </div>
              <button type="button"
                      class="btn"
                      style="width: 300px; background-color: #000000; color: #ffffff; padding: 0.5em 1.2em;
                             font-family: 'Rubik', serif; font-size: 14px; font-weight: 600;
                             white-space: nowrap;"
                      [disabled]="hotelSuggestLoading || hotelSuggestEnriching"
                      (click)="runHotelSuggestSearch()">
                <span *ngIf="!hotelSuggestLoading && !hotelSuggestEnriching">Buscar</span>
                <span *ngIf="hotelSuggestLoading"
                      class="d-flex align-items-center"
                      style="gap: 0.4em;">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Buscando...
                </span>
                <span *ngIf="hotelSuggestEnriching"
                      class="d-flex align-items-center"
                      style="gap: 0.4em;">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Procesando...
                </span>
              </button>
            </div>

            <!-- Mensaje de error -->
            <span *ngIf="hotelSuggestError"
                  class="text-danger mt-2"
                  style="font-size: 12px; font-weight: 600;">
              {{ hotelSuggestError }}
            </span>

            <!-- Mensaje de pending (enriquecimiento async tardó) -->
            <div *ngIf="hotelSuggestPending"
                 class="d-flex align-items-center mt-2"
                 style="gap: 0.5em; font-family: 'Rubik', serif; font-size: 13px;">
              <span class="text-warning" style="font-weight: 600;">
                El hotel se está procesando. Intentá de nuevo en unos segundos.
              </span>
              <button type="button"
                      class="btn btn-sm"
                      style="background-color: #ffffff; border: 1px solid #ececec; padding: 0.3em 0.7em;
                             font-family: 'Rubik', serif; font-size: 12px;"
                      (click)="selectHotelSuggestion(hotelSuggestResults[0])">
                Reintentar
              </button>
            </div>

            <!-- Lista de sugerencias -->
            <div *ngIf="hotelSuggestResults.length > 0"
                 class="d-flex flex-column mt-2"
                 style="background-color: white; border: 1px solid #ececec; border-radius: 4px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.08); max-height: 280px; overflow-y: auto;">

              <div class="d-flex justify-content-between align-items-center px-2"
                   style="background-color: #f4f4f4; height: 42px;">
                <div class="d-flex align-items-center" style="gap: 0.25em;">
                  <img src="../../../../assets/icons/search-box/hotel_gris.svg"
                       style="width: 35px; height: 35px;" />
                  <span class="mt-1"
                        style="font-family: 'Rubik', serif; font-size: 13px !important;
                               font-weight: 600 !important;">
                    Sugerencias
                  </span>
                </div>
                <span style="font-family: 'Rubik', serif; font-size: 11px !important;
                            font-weight: 400 !important;">
                  {{ hotelSuggestResults.length }} resultados
                </span>
              </div>

              <button *ngFor="let h of hotelSuggestResults"
                      type="button"
                      class="d-flex align-items-start mb-0 px-2 py-2"
                      style="background-color: white; border: none; border-bottom: 1px solid #f4f4f4;
                             text-align: left; cursor: pointer; font-family: 'Rubik', serif;
                             width: 100%;"
                      (mouseenter)="h._hover = true"
                      (mouseleave)="h._hover = false"
                      [style.background-color]="h._hover ? '#f9f9f9' : 'white'"
                      (click)="selectHotelSuggestion(h)">
                <div class="d-flex align-items-start" style="gap: .75em; margin-left: 9px; width: 100%;">
                  <img *ngIf="h.image_urls && h.image_urls.length > 0"
                       [src]="h.image_urls[0]"
                       style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover; margin-top: 2px;" />
                  <div class="d-flex flex-column" style="flex: 1; min-width: 0;">
                    <p class="mb-0"
                       style="font-family: 'Rubik'; font-size: 14px !important;
                              font-weight: 600 !important; line-height: 1.2;
                              color: #333;">
                      {{ h.name || h.hotel_name || h.title || 'Hotel sin nombre' }}
                    </p>
                    <span *ngIf="h.description"
                          class="mb-0"
                          style="font-family: 'Rubik'; font-size: 12px !important;
                                line-height: 1.2; font-weight: 400 !important;
                                color: #666; margin-top: 2px;">
                      {{ h.description }}
                    </span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="d-flex mt-4" style="gap: 1em;">
          <!-- Régimen -->
          <div class="card-option d-flex flex-column" style="width: 33%;">
              <span class="section-title card-label mb-2">Régimen</span>
                <div *ngFor="let val of boardType; let i = index" >
                  <label class="option-item"
                         [ngStyle]="{'border-bottom': i !== (boardType.length - 1) ? '1px solid rgba(229,229,229,0.8)' : ''}">
                       <span class="option-label"><strong>{{val.description}}</strong> - {{val.label}}</span>
                       <span class="custom-checkbox">
                         <input
                           type="checkbox"
                           [value]="val.value"
                           [disabled]="edit"
                           (change)="onChangeSelectForm($event,'hotel', 'meals')"
                           [checked]="formHotel.get('meals').value.includes(val.value)"
                         />
                         <span class="checkbox-visual"></span>
                       </span>
                 </label>
                </div>
            </div>
            <!-- Categoría habitación -->
            <div class="card-option d-flex flex-column" style="width: 33%;">
              <span class="section-title card-label mb-2">Categoría habitación</span>
                <div *ngFor="let val of roomType; let i = index">
                  <label class="option-item"
                              [ngStyle]="{'border-bottom': i !== (roomType.length - 1) ? '1px solid rgba(229,229,229,0.8)' : ''}">
                  <span class="option-label">{{val.label}}</span>
                  <span class="custom-checkbox">
                    <input
                      type="checkbox"
                      [value]="val.value"
                      [disabled]="edit"
                      (change)="onChangeSelectForm($event,'hotel', 'category')"
                      [checked]="formHotel.get('category').value.includes(val.value)"
                    />
                    <span class="checkbox-visual"></span>
                  </span>
                 </label>
                </div>
            </div>
            <!-- Tipo cama -->
            <div class="card-option d-flex flex-column" style="width: 33%;">
              <span class="section-title card-label mb-2">Tipo cama</span>
                <div *ngFor="let val of bedType; let i = index">
                  <label class="option-item"
                               [ngStyle]="{'border-bottom': i !== (bedType.length - 1) ? '1px solid rgba(229,229,229,0.8)' : ''}">
                  <span class="option-label">{{val.label}}</span>
                  <span class="custom-checkbox">
                    <input
                      type="checkbox"
                      [value]="val.value"
                      [disabled]="edit"
                      (change)="onChangeSelectForm($event,'hotel', 'type_bed')"
                      [checked]="formHotel.get('type_bed').value.includes(val.value)"
                    />
                    <span class="checkbox-visual"></span>
                  </span>
                 </label>
                </div>
            </div>
        </div>
        <div class="d-flex mt-3 mb-3" style="gap: 1em; ">
          <div class="d-flex flex-column" style="width: 100%;">
              <p class="mb-1" class="section-title">Habitaciones y pasajeros</p>

              <button
                type="button"
                class="d-flex justify-content-between align-items-center form-control"
                (click)="openModal(); setRoomAndPassengers()"
                class="btn-rooms-passengers"
                [disabled]="edit"
              >
                {{ roomsAndPassengers }}
                <img width="10" height="10" src="../../../../assets/img/app/little-icons/arrow-down-black.svg" />
              </button>

              <!-- Modal selector -->
              <div *ngIf="isCollapsed" class="d-flex flex-column mt-2 config-passenger" style="position: relative; width: 100%;">
                <div class="card py-4 pl-5 pr-5 scrollable-card-container" style="width: 100%; min-width: 100%;">
                  <!-- Header: Adultos / Niños -->
                  <div class="d-flex align-items-center justify-content-center" style="gap: 40px; margin-bottom: 15px;">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                      <label class="mb-0" style="font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1;">Adultos</label>
                      <p class="mb-0" style="font-family: 'Rubik' !important; font-size: 11px !important; font-weight: 400 !important; line-height: 1;">+ de 18 años</p>
                    </div>
                    <div class="container-label d-flex">
                      <div class="d-flex flex-column align-items-start">
                        <div class="d-flex" style="line-height: 1;">
                          <label class="mb-0" style="font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1;">Niños</label>
                        </div>
                        <p class="mb-0" style="font-family: 'Rubik' !important; font-size: 11px !important; font-weight: 400 !important; line-height: 1;">- de 18 años</p>
                      </div>
                    </div>
                  </div>

                  <!-- Rooms -->
                  <div class="room-content">
                    <ng-container formArrayName="room">
                      <div *ngFor="let item of formRoom(formHotel, 'room'); let i = index" class="d-flex flex-row col-12 align-items-center justify-content-between p-2">
                        <div [formGroupName]="i" style="width: 100%;" [ngStyle]="{ 'border-bottom': formRoom(item, 'childsage').length > 0 ? 'none' : '2px dotted #9c9c9c'}">
                          <div class="d-flex flex-column">
                            <div class="d-flex flex-row align-items-center justify-content-between p-0 pb-3">
                              <div>
                                <div class="mr-2 ml-1" style="font-family: 'Rubik'; font-size: 14px; font-weight: 500; width: 50px">Hab: {{ i + 1 }}</div>
                              </div>
                              <div class="d-flex flex-column align-items-center p-0 m-0 mr-2 ml-3">
                                <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                                  <button type="button" class="pr-2" style="border: none; background-color: transparent" (click)="decrementPassengerAdult(i, $event)" [disabled]="getPassengerCountAdult(i) <= 1">
                                    <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                                  </button>
                                  <input type="number" class="form-control text-center" style="border-radius: 8px; max-width: 45px; padding: 0 !important" [value]="getPassengerCountAdult(i)" [min]="1" [max]="10" (change)="validatePassengerInput($event, i)" (keydown)="handleAdultInput($event, i)" (blur)="handleAdultBlur($event, i)" (click)="preventModalClose($event)" name="adults" />
                                  <button type="button" class="pl-2" style="border: none; background-color: transparent" (click)="incrementPassengerAdult(i, $event)" [disabled]="getPassengerCountAdult(i) >= 10">
                                    <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                                  </button>
                                </div>
                              </div>
                              <div class="d-flex flex-column align-items-center p-0 m-0 mr-3 ml-2">
                                <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                                  <button type="button" style="border: none; background-color: transparent" class="pr-2" (click)="decrementPassengerChildren(i, item, $event)" [disabled]="getPassengerCountChildren(i) <= 0">
                                    <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                                  </button>
                                  <input type="number" class="form-control text-center" style="border-radius: 8px; max-width: 45px; padding: 0 !important" [value]="getPassengerCountChildren(i)" [min]="0" [max]="10" (change)="validatePassengerInput($event, i)" (keydown)="handleChildrenInput($event, i)" (blur)="handleChildrenBlur($event, i)" (click)="preventModalClose($event)" name="children" />
                                  <button type="button" style="border: none; background-color: transparent" class="pl-2" (click)="incrementPassengerChildren(i, item, $event)" [disabled]="getPassengerCountChildren(i) >= 10">
                                    <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                                  </button>
                                </div>
                              </div>
                              <div id="childrenAges" class="d-flex flex-column ml-2" *ngIf="item.get('childsage').length > 0">
                                <div *ngIf="hasChildAgeError(item, 'childsage')">
                                  <span class="help-block text-danger d-flex w-100 text-nowrap">La edad de los niños es incorrecta</span>
                                </div>
                              </div>
                              <div class="p-0 d-flex flex-column ml-auto ml-2">
                                <button type="button" (click)="removeRoom(i, $event)" class="ml-2 btn btn-outline-danger col-12 input-age btn-sm" style="min-height: 35px !important; width: 45px !important; height: 45px !important; border-radius: 8px; border: 1px solid #ced4da !important;" [disabled]="formRoom(formHotel, 'room').length <= 1">
                                  <i class="bi bi-x-lg" style="color: black; font-size: 16px; -webkit-text-stroke: 0.5px"></i>
                                </button>
                              </div>
                            </div>
                            <div>
                              <div *ngIf="formRoom(item, 'childsage').length > 0" class="d-flex flex-column p-4 m-0" style="border-radius: 10px; background-color: #f4f4f4">
                                <div class="d-flex flex-column align-items-start mb-3 ml-1">
                                  <label class="mb-0" style="font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1; text-wrap: nowrap;" for="adults">Edad niños <span style="font-weight: 400 !important; font-size: 12px !important;">- de 18 años</span></label>
                                </div>
                                <!-- Primera fila (índices 0-4) -->
                                <div class="d-flex mb-3">
                                  <div formArrayName="childsage" *ngFor="let age of formRoom(item, 'childsage'); let j = index">
                                    <div *ngIf="j >= 0 && j <= 3">
                                      <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                        <select name="age" id="age" formControlName="age" [ngStyle]="{ 'margin-left': j > 0 ? '1em' : '' }" class="form-control custom-select-arrow" style="height: 35px !important; padding: 0 !important; width: 60px !important; font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; text-align: left; padding-left: 13px !important; background-color: #FFFFFF !important; border-radius: 12px;">
                                          <ng-container *ngFor="let value of agesChildsArr()">
                                            <option value="{{ value }}">{{ value }}</option>
                                          </ng-container>
                                        </select>
                                        <span style="position: absolute; top: 42%; right: 0.5em; width: 0; height: 0; border-left: 4px solid transparent; border-right: 4px solid transparent; border-top: 6px solid #00d096;"></span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Segunda fila (índices 5-9) -->
                                <div class="d-flex mb-3">
                                  <div formArrayName="childsage" *ngFor="let age of formRoom(item, 'childsage'); let j = index">
                                    <div *ngIf="j >= 4 && j <= 7">
                                      <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                        <select name="age" id="age" formControlName="age" [ngStyle]="{ 'margin-left': j > 4 ? '1em' : '' }" class="form-control custom-select-arrow" style="height: 35px !important; padding: 0 !important; width: 60px !important; font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; text-align: left; padding-left: 13px !important; background-color: #FFFFFF !important; border-radius: 12px;">
                                          <ng-container *ngFor="let value of agesChildsArr()">
                                            <option value="{{ value }}">{{ value }}</option>
                                          </ng-container>
                                        </select>
                                        <span style="position: absolute; top: 42%; right: 1em; width: 0; height: 0; border-left: 4px solid transparent; border-right: 4px solid transparent; border-top: 6px solid #00d096;"></span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Tercera fila (índices 8-9) -->
                                <div class="d-flex">
                                  <div formArrayName="childsage" *ngFor="let age of formRoom(item, 'childsage'); let j = index">
                                    <div *ngIf="j >= 8 && j <= 9">
                                      <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                        <select name="age" id="age" formControlName="age" [ngStyle]="{ 'margin-left': j === 9 ? '1em' : '' }" class="form-control custom-select-arrow" style="height: 35px !important; padding: 0 !important; width: 60px !important; font-family: 'Rubik' !important; font-size: 14px !important; font-weight: 600 !important; text-align: left; padding-left: 13px !important; background-color: #FFFFFF !important; border-radius: 12px;">
                                          <ng-container *ngFor="let value of agesChildsArr()">
                                            <option value="{{ value }}">{{ value }}</option>
                                          </ng-container>
                                        </select>
                                        <span style="position: absolute; top: 42%; right: 1em; width: 0; height: 0; border-left: 4px solid transparent; border-right: 4px solid transparent; border-top: 6px solid #00d096;"></span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!-- Botones: Agregar Habitación + Confirmar -->
                  <div class="py-2 row">
                    <div class="col-6 p-2">
                      <button type="button" (click)="addRoom($event)" class="badge btn-choice-add" style="background-color: transparent; min-width: 145px; width: 100%; height: 36px; border: 1px solid #00d096;" (mouseenter)="isHoverRoom = true; updateButtonColorRoom()" (mouseleave)="isHoverRoom = false; updateButtonColorRoom()">
                        Agregar Habitación
                      </button>
                    </div>
                    <div class="col-6 p-2">
                      <button (click)="confirmRoomsAndPassengers($event)" class="badge btn-choice-confirm" style="border: none; min-width: 145px; width: 100%; height: 36px; background-color: #00d096; color: white;" type="button" (mouseenter)="isHoverConfirm = true; updateButtonColorConfirm()" (mouseleave)="isHoverConfirm = false; updateButtonColorConfirm()">
                        Confirmar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="d-flex flex-column " style="width: 100%;">
            <p class="mb-1" class="section-title">Presupuesto</p>
             <div class="d-flex mb-1" style="gap: 1em;">
                <div class="position-relative w-100" >
                  <input type="number" min="1" class="form-control" id="price_night" name="price_night" placeholder="Presupuesto" (keypress)="limitNumber($event, 9999999)" max="9999999"  (keydown)="blockInvalidKeys($event, 'number')" formControlName="price_night">
                  <span *ngIf="formHotel.get('price_night').value && formHotel.get('price_night')?.value < 9999999"
                        class="position-absolute ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px;color: #cbcbcb "
                    >Número sin "," ni "."
                   </span>
                   <span *ngIf="formHotel.get('price_night')?.value === 9999999"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px; font-weight: 600; bottom: -20px;">
                   Máximo 9999999
                 </span>
                </div>
             </div>
          </div>
        </div>
         <div class="d-flex">
          <div class="w-100 position-relative">
            <!-- Sin nacionalidad elegida: input con autocomplete de países -->
            <ng-container *ngIf="selectNationalityName === ''">
              <input
                type="text"
                id="nationality"
                name="nationality"
                matInput
                class="form-control"
                placeholder="Nacionalidad"
                autocomplete="off"
                formControlName="nationality"
                [matAutocomplete]="autoNationality"
                (focus)="getNationalities()"
                (input)="filterNationalities($any($event.target).value)"
              />
              <mat-autocomplete
                #autoNationality="matAutocomplete"
                (optionSelected)="onNationalitySelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let country of filteredNationalities"
                  [value]="country.country_name"
                  style="font-family: 'Rubik', serif; padding: 0px 10px !important; height: 35px !important"
                >
                  {{ country.country_name }}
                </mat-option>
              </mat-autocomplete>
            </ng-container>

            <!-- Nacionalidad elegida: readonly + X para borrar -->
            <ng-container *ngIf="selectNationalityName !== ''">
              <input
                type="text"
                id="nationality"
                name="nationality"
                class="form-control"
                aria-label="nationality"
                [value]="selectNationalityName"
                style="padding-right: 38px;"
              />
              <span *ngIf="!edit"
                    class="position-absolute d-flex align-items-center justify-content-center"
                    style="top: 0; right: 0; height: 100%; width: 38px; cursor: pointer;"
                    tooltip="Eliminar nacionalidad"
                    placement="bottom"
                    (click)="resetNationality()">
                <i class="bi bi-x" style="font-size: 20px; color: #999;"></i>
              </span>
            </ng-container>
          </div>
          <div>
            <!-- <input type="text" formControlName="currency"> -->
          </div>
        </div>

          <div class="d-flex mt-3 flex-column">
          <span class="section-title">Comentario</span>
          <div class="d-flex flex-column">
            <div class="w-100 position-relative">
              <textarea name="comment_contact" id="comment_contact" class="form-control comment-textarea" placeholder="Pregunta o comentario" [maxLength]="500" formControlName="comment_contact" rows="5" id=""></textarea>
               <span *ngIf="formHotel.get('comment_contact').value?.length === 500"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 500 caracteres
                </span>
            </div>
          </div>
         </div>

          <!-- Sección Competencia -->
          <div class="d-flex mt-3 flex-column">

            <!-- Estado colapsado: solo el botón "Generar competencia" -->
            <div class="d-flex align-items-center justify-content-end" *ngIf="!competitorSectionOpen && competitorUrlsArray.length === 0">
              <div class="d-flex flex-column align-items-end" style="gap: 0.25em;">
                <button *ngIf="!edit"
                        type="button"
                        class="btn-expand-search"
                        [disabled]="!canEditCompetitor"
                        [tooltip]="!canEditCompetitor ? 'Completá los campos obligatorios del formulario para habilitar competencia' : null"
                        (click)="openCompetitorSection()">
                  <span class="expand-icon">+</span>
                  Generar competencia
                </button>
                <span *ngIf="!edit && !canEditCompetitor"
                      style="font-family: 'Rubik', serif; font-size: 11px; color: #999;">
                  Completá los campos obligatorios para habilitar competencia
                </span>
                <p *ngIf="edit"
                   class="mb-0"
                   style="font-family: 'Rubik', serif; font-size: 13px; color: #999;">
                  Sin datos de competencia.
                </p>
              </div>
            </div>

            <!-- Estado expandido: URLs + imágenes -->
            <div *ngIf="competitorSectionOpen || competitorUrlsArray.length > 0"
                 class="d-flex flex-column">
              <p class="mb-1" class="section-title">Competencia</p>

              <!-- Header del desplegable con botón para colapsar -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <span style="font-family: 'Rubik', serif; font-size: 13px; color: #666;">
                  URLs de la competencia
                </span>
                <button *ngIf="!edit"
                        type="button"
                        class="btn"
                        style="border: none; background: transparent; font-size: 18px; color: #999; padding: 0;"
                        [disabled]="!canEditCompetitor"
                        (click)="closeCompetitorSection()"
                        aria-label="Cerrar sección competencia">
                  ×
                </button>
              </div>

              <!-- Lista de URLs (cada una con su input + botón X + botón + al final) -->
              <div formArrayName="competitorUrls">
                <div *ngFor="let urlCtrl of competitorUrlsArray.controls; let i = index"
                     class="competitor-url-row mb-2 position-relative">
                  <span class="url-link-icon">🔗</span>
                  <input
                    type="text"
                    class="form-control field-input"
                    [id]="'competitorUrl_' + i"
                    [name]="'competitorUrl_' + i"
                    placeholder="URL de la competencia"
                    [maxLength]="500"
                    [formControlName]="i"
                    [readonly]="edit || !canEditCompetitor"
                  />
                  <button *ngIf="!edit"
                          type="button"
                          (click)="addCompetitorUrl()"
                          [disabled]="!canEditCompetitor"
                          aria-label="Agregar URL"
                          class="btn-url-add">
                    +
                  </button>
                  <button *ngIf="!edit && competitorUrlsArray.length > 1"
                          type="button"
                          (click)="removeCompetitorUrl(i)"
                          [disabled]="!canEditCompetitor"
                          aria-label="Quitar URL"
                          class="btn-url-remove">
                    ×
                  </button>
                  <span *ngIf="urlCtrl.hasError('pattern') && urlCtrl.touched"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 11px; font-weight: 600; bottom: -18px; left: 0;">
                    URL inválida (debe comenzar con http:// o https://)
                  </span>
                </div>
              </div>

              <!-- Prints (colección global de imágenes) -->
              <div class="d-flex flex-column mt-3 mb-2">
                <p class="mb-1" style="font-family: 'Rubik', serif; font-weight: 500; font-size: 14px;">Prints</p>
                <span *ngIf="!edit" class="mb-2"
                      style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 400; color: #cbcbcb;">
                  Máx. 5 MB por imagen. Formatos: JPG, PNG, WEBP.
                </span>

                <input
                  *ngIf="!edit"
                  type="file"
                  accept="image/*"
                  multiple
                  class="form-control mb-2"
                  id="competitorImages"
                  name="competitorImages"
                  [disabled]="!canEditCompetitor"
                  (change)="onCompetitorImagesSelected($event)"
                />

                <div *ngIf="competitorImagesArray.length > 0"
                     class="d-flex flex-row flex-wrap"
                     style="gap: 0.5em;">
                  <div *ngFor="let img of competitorImagesArray.controls; let i = index"
                       class="position-relative"
                       style="width: 96px; height: 96px;">
                    <img [src]="'data:image/jpeg;base64,' + img.value"
                         style="width: 96px; height: 96px; object-fit: cover; border-radius: 6px; border: 1px solid #ececec;" />
                    <button *ngIf="!edit"
                            type="button"
                            (click)="removeCompetitorImage(i)"
                            aria-label="Quitar imagen"
                            style="position: absolute; top: 2px; right: 2px; width: 22px; height: 22px;
                                   border-radius: 50%; border: none; background-color: rgba(0,0,0,0.6);
                                   color: white; font-size: 12px; line-height: 1; cursor: pointer; padding: 0;">
                      ×
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Fin sección Competencia -->
          <div *ngIf="!edit" class="form-footer">
            <p class="footer-disclaimer mb-0">Puede completar todos los formularios en una sola solicitud</p>
            <div class="footer-actions">
              <button type="button" class="btn-borrar" (click)="close()">Borrar</button>
              <button type="button" class="btn-enviar" (click)="onSubmit()">Enviar</button>
            </div>
          </div>
        </div><!-- end .form-body -->
      </form>
    </div>
    <div [ngClass]="{'d-block': tab==='transfer', 'd-none': tab!='transfer' }">
      <form *ngIf=" tab==='transfer'" [formGroup]="formTransfer">


        <div class="d-flex flex-column mt-3 mb-3 position-relative">
          <span class="section-title">Destino y fechas</span>
          <div class="d-flex position-relative mb-3" style="gap: 1em;">
                    <div class="position-relative" style="width: 100%">
                      <div class="d-flex flex-column" style="width: 100%">
                        <label *ngIf="edit" for="firstOrigin" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Origen</label>
                        <input type="text" id="firstOrigin" name="firstOrigin" [maxLength]="50" formControlName="firstOrigin" placeholder="Origen" class="form-control">

                           <span  *ngIf="formTransfer.get('firstOrigin').hasError('required')"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                            Obligatorio</span>
                    <span *ngIf="formTransfer.get('firstOrigin').hasError('minlength') &&
                            formTransfer.get('firstOrigin').touched"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Mínimo 3 caracteres
                </span>
                <span *ngIf="formTransfer.get('firstOrigin').value?.length === 50"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 50 caracteres
                </span>


                      </div>

                    </div>

            <div class="position-relative" style="width: 100%">
                    <div class="d-flex flex-column " style="width: 100%">
                      <label *ngIf="edit" for="firstOrigin" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Destino</label>
                      <input type="text" id="firstDestination" name="firstDestination" [maxLength]="50" placeholder="Destino" formControlName="firstDestination" class="form-control">
                    </div>
                <span  *ngIf="formTransfer.get('firstDestination').hasError('required')"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                  Obligatorio</span>
                <span *ngIf="formTransfer.get('firstDestination').hasError('minlength') &&
                            formTransfer.get('firstDestination').touched"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Mínimo 3 caracteres
                </span>
                <span *ngIf="formTransfer.get('firstDestination').value?.length === 50"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 50 caracteres
                </span>
            </div>
          </div>
        </div>

        <div class="d-flex  mb-4">
          <div class="d-flex w-100" style="gap: 1em;">
            <div class="w-100 d-flex flex-column position-relative">
              <label *ngIf="edit" for="firstArrivalDate" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Fecha ida</label>
              <input
              formControlName="firstArrivalDate"
              type="text"
              class="form-control input-search-box"
              style="background-color: white;"
              id="departureDate"
              placeholder="Fecha de recogida"
              autocomplete="off"
              bsDatepicker
              [minDate]="now"
              [bsConfig]="dpConfig"
              readonly
              [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': clientSetting?.clients_setting_global?.color_main_1},
                          ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': clientSetting?.clients_setting_global?.color_main_1}}"
            />
                  <span  *ngIf="formTransfer.get('firstArrivalDate').value === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                        Obligatorio</span>
            </div>
            <div class="w-100 position-relative d-flex flex-column">
               <label *ngIf="edit" for="firstTime" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Hora ida</label>
               <input
                  class="form-control input-search-box"
                  formControlName="firstTime"
                  type="time">
                  <span  *ngIf="formTransfer.get('firstArrivalDate').value === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                        Obligatorio</span>
            </div>

            <!-- <div class="d-flex w-100">
                <input type="text" class="form-control" placeholder="Número vuelo ida" formControlName="flyNumberIn">
            </div> -->
          </div>
        </div>

         <div class="d-flex mb-4">
          <div *ngIf="!edit" class="d-flex mb-3 w-100" style="gap: 1em;">
              <div class="w-100 d-flex flex-column">
                <input
                  formControlName="secondArrivalDate"
                  type="text"
                  class="form-control input-search-box"
                  style="background-color: white;"
                  id="departureDate"
                  placeholder="Fecha de vuelta"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="formTransfer.get('firstArrivalDate')?.value ? formTransfer.get('firstArrivalDate')?.value  : now"
                  [bsConfig]="dpConfig"
                  [disabled]="!formTransfer.get('firstArrivalDate')?.value"
                  (bsValueChange)="onDateChange($event)"
                />
              </div>
              <div class="w-100">
                          <input
                  class="form-control input-search-box"
                  formControlName="secondTime"
                  type="time">
              </div>
            </div>
            <div *ngIf="edit && formTransfer.get('secondArrivalDate').value !== null" class="d-flex mb-3 w-100" style="gap: 1em;">
              <div class="w-100 d-flex flex-column">
                <label *ngIf="edit" for="secondArrivalDate" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Fecha vuelta</label>
                <input
                  formControlName="secondArrivalDate"
                  type="text"
                  class="form-control input-search-box"
                  style="background-color: white;"
                  id="departureDate"
                  placeholder="Fecha de vuelta"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="formTransfer.get('firstArrivalDate').value"
                  [bsConfig]="dpConfig"
                  (bsValueChange)="onDateChange($event)"
                />
              </div>
              <div class="w-100 d-flex flex-column">
                <label *ngIf="edit" for="secondTime" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Fecha vuelta</label>
                          <input
                  class="form-control input-search-box"
                  formControlName="secondTime"
                  type="time">
              </div>
            </div>
            <!-- <div class="w-100">
                <input type="text" class="form-control" placeholder="Número vuelo vuelta" formControlName="flyNumberOut">
            </div> -->

        </div>

        <div class="d-flex flex-column mt-3 mb-3">
          <p class="mb-1" class="section-title">Pasajeros</p>
          <div class="d-flex mb-4" style="gap: 1em;">
            <div class="w-100 position-relative">
              <input type="text" id="qty_bags" name="qty_bags" min="0" max="99" (keypress)="limitNumber($event, 99)" (keydown)="blockInvalidKeys($event, 'number')" class="form-control" placeholder="Cantidad Maletas" formControlName="qty_bags">
              <span   *ngIf="formTransfer.get('qty_bags')?.value === 99"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Máximo 99
              </span>
            </div>
            <div class="w-100 position-relative">
              <input type="number" id="adults" name="adults" min="0" max="99" class="form-control" (keypress)="limitNumber($event, 99)" (keydown)="blockInvalidKeys($event, 'number')" placeholder="Cantidad adultos" formControlName="adults">
                <span  *ngIf="formTransfer.get('adults').hasError('required')"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                        Obligatorio</span>
                <span   *ngIf="formTransfer.get('adults')?.hasError('min')"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Mínimo 1
                   </span>
                    <span   *ngIf="formTransfer.get('adults')?.value === 99"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Máximo 99
                   </span>
            </div>
          </div>
          <div class="d-flex mb-3" style="gap: 1em;">
            <div class="w-100 position-relative">
              <input type="number" min="0" max="99" class="form-control" (keypress)="limitNumber($event, 99)" (keydown)="blockInvalidKeys($event, 'number')" placeholder="Cantidad niños" formControlName="childs">
               <span  *ngIf="formTransfer.get('childs').value === null || formTransfer.get('childs').value === ''"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                        Obligatorio</span>
                <span *ngIf="formTransfer.get('childs')?.value === 99"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 99
                </span>
            </div>
            <div class="w-100 position-relative">
              <input type="text" class="form-control" id="age_childs" name="age_childs" placeholder="Edades de los niños. Ej: 1, 4, 7" (keydown)="blockInvalidKeys($event, 'age_childs')" formControlName="age_childs">
              <span *ngIf="
                              !formTransfer.get('age_childs').valid && formHotel.get('childs').value > 0"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                    <span *ngIf="
                              formTransfer.get('age_childs').value"
                        class="position-absolute ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px;color: #cbcbcb "
                    >Ej: 1, 4, 7
                   </span>
            </div>
          </div>
        </div>

        <div class="d-flex" style="gap: 1em;">
           <div class="card-option d-flex flex-column" style="width: 25%;">
              <span class="section-title card-label mb-2">Modalidad</span>
              <div *ngFor="let val of typeTransfer; let i = index">
                <label class="option-item"
                 [ngStyle]="{'border-bottom': i !== (typeTransfer.length - 1) ? '1px solid rgba(229,229,229,0.8)' : ''}">
                  <span class="option-label">{{val.label}}</span>
                   <span class="custom-checkbox">
                     <input
                       type="checkbox"
                       [value]="val.value"
                       [disabled]="edit"
                       (change)="onChangeSelectForm($event,'transfer', 'typeTransfer')"
                       [checked]="formTransfer.get('typeTransfer').value.includes(val.value)"
                     />
                     <span class="checkbox-visual"></span>
                   </span>
                 </label>
              </div>
            </div>

              <div class="card-option d-flex flex-column" style="width: 75%;">
              <span class="section-title card-label mb-2">Vehículo</span>
               <span class="d-flex flex-row flex-wrap w-100" >
                <div *ngFor="let val of vehicleTypes; let i = index" class="pr-3" style=" min-width: 20%;">
                    <label class="option-item"
                    [ngStyle]="{'border-bottom': i < 5 ? '1px solid rgba(229,229,229,0.8)' : ''}">
                      <span class="option-label">{{val.label}}</span>
                      <span class="custom-checkbox">
                        <input
                          type="checkbox"
                          [value]="val.value"
                          [disabled]="edit"
                          (change)="onChangeSelectForm($event,'transfer', 'typeVehicle')"
                          [checked]="formTransfer.get('typeVehicle').value.includes(val.value)"
                        />
                        <span class="checkbox-visual"></span>
                      </span>
                    </label>
                  </div>
                </span>
        </div>

        </div>

          <div class="d-flex mt-3 flex-column">
          <span class="section-title">Comentario</span>
          <div class="d-flex flex-column">
            <div class="w-100 position-relative">
              <textarea name="comment_contact" id="comment_contact" class="form-control comment-textarea" placeholder="Pregunta o comentario" formControlName="comment_contact" rows="5" id=""></textarea>
               <span *ngIf="formTransfer.get('comment_contact').value?.length === 500"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 500 caracteres
                </span>
            </div>
          </div>
         </div>


              <div *ngIf="!edit" class="form-footer">
              <p class="footer-disclaimer mb-0">*Puede completar todos los formularios en una sola solicitud</p>
              <div class="footer-actions">
                <button type="button" class="btn-borrar" (click)="close()">Borrar</button>
                <button type="button" class="btn-enviar" (click)="onSubmit()">Enviar</button>
              </div>
            </div>
      </form>
    </div>

    <div [ngClass]="{'d-block': tab==='rent-a-car', 'd-none': tab!='rent-a-car' }">
      <form *ngIf=" tab==='rent-a-car'" [formGroup]="formRentACar">

        <div class="d-flex flex-column mt-3 mb-3 w-100">
          <p class="mb-1" class="section-title">Fecha y dirección de recogida</p>
          <div class="d-flex mb-4" style="gap: 1em;">
              <div class="w-100 position-relative">
                <input type="text" id="origin" name="origin" class="form-control" [maxLength]="50"  placeholder="Lugar de recogida" (keydown)="blockInvalidKeys($event, 'name')" formControlName="origin">
                   <span *ngIf="
                            formRentACar.get('origin').hasError('required')"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
              >
                Obligatorio</span>
                 <span *ngIf="formRentACar.get('origin').hasError('minlength') &&
                            formRentACar.get('origin').touched"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Mínimo 3 caracteres
                </span>
                <span *ngIf="formRentACar.get('origin').value?.length === 50"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 50 caracteres
                </span>
              </div>
          </div>
           <div class="d-flex mb-3" style="gap: 1em;">
              <div class="w-100 position-relative">
                <input type="text" id="destinationReturn" name="destinationReturn" [maxLength]="50" class="form-control" (keydown)="blockInvalidKeys($event, 'name')" placeholder="Retorno en otra ubicación (ingrese el lugar de retorno)" formControlName="destinationReturn">
                <span *ngIf="formRentACar.get('destinationReturn').hasError('minlength') &&
                            formRentACar.get('destinationReturn').touched"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Mínimo 3 caracteres
                </span>
                <span *ngIf="formRentACar.get('destinationReturn').value?.length === 50"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 50 caracteres
                </span>
              </div>
          </div>
        </div>

    <div class="d-flex" style="gap: 1em;">

      <div class="d-flex flex-column w-100">

        <div class="w-100 mb-4 position-relative">
          <input
          formControlName="pickupDate"
          type="text"
          class="form-control input-search-box"
          style="background-color: white;"
          id="departureDate"
          placeholder="Fecha retiro"
          autocomplete="off"
          bsDatepicker
          [minDate]="now"
          [bsConfig]="dpConfig"
          readonly
          [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': clientSetting?.clients_setting_global?.color_main_1},
                      ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': clientSetting?.clients_setting_global?.color_main_1}}"
        />
           <span *ngIf="
                            formRentACar.get('pickupDate').value === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
              >
                Obligatorio</span>
        </div>
    <div class="card-option d-flex flex-column w-100">

      <span class="section-title card-label mb-2">Horario traslado Retiro
        <span *ngIf="formRentACar.get('pickupTimeDay')?.value.length === 0"
                     class="text-danger ml-1"
                     style="font-size: 12px;font-weight: 600;">
                Obligatorio</span>
      </span>
                <div  *ngFor="let val of timeDay; let i = index">
                    <label class="option-item"
                         [ngStyle]="{'border-bottom': i !== (timeDay.length - 1) ? '1px solid rgba(229,229,229,0.8)' : ''}">
                    <span class="option-label">{{val.label}}</span>
                     <span class="custom-checkbox">
                       <input
                         type="checkbox"
                         [value]="val.value"
                         [disabled]="edit"
                         (change)="onChangeSelectForm($event,'rent-a-car', 'pickupTimeDay')"
                         [checked]="formRentACar.get('pickupTimeDay').value.includes(val.value)"
                       />
                       <span class="checkbox-visual"></span>
                     </span>
                   </label>
                </div>
    </div>
    </div>


 <div class="d-flex flex-column w-100">


               <div class="w-100 mb-4 position-relative">
                <input
                formControlName="dropoffDate"
                type="text"
                class="form-control input-search-box"
                style="background-color: white;"
                id="departureDate"
                placeholder="Fecha devolución"
                autocomplete="off"
                bsDatepicker
                [minDate]="now"
                [bsConfig]="dpConfig"
                readonly
                [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': clientSetting?.clients_setting_global?.color_main_1},
                            ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': clientSetting?.clients_setting_global?.color_main_1}}"
              />
                <span *ngIf="
                            formRentACar.get('dropoffDate')?.value === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
              >
                Obligatorio</span>
              </div>

    <div class="card-option d-flex flex-column w-100">
      <span class="section-title card-label mb-2">Horario traslado devolución
          <span *ngIf="formRentACar.get('dropoffTimeDay')?.value.length === 0"
                     class="text-danger ml-1"
                     style="font-size: 12px;font-weight: 600;">
                Obligatorio</span>
      </span>
        <div  *ngFor="let val of timeDay; let i = index">
                    <label class="option-item"
                         [ngStyle]="{'border-bottom': i !== (timeDay.length - 1) ? '1px solid rgba(229,229,229,0.8)' : ''}">
                    <span class="option-label">{{val.label}}</span>
                      <span class="custom-checkbox">
                        <input
                          type="checkbox"
                          [value]="val.value"
                          [disabled]="edit"
                          (change)="onChangeSelectForm($event,'rent-a-car', 'dropoffTimeDay')"
                          [checked]="formRentACar.get('dropoffTimeDay').value.includes(val.value)"
                        />
                        <span class="checkbox-visual"></span>
                      </span>
                    </label>
            </div>
    </div>

            </div>
          </div>

        <div class="d-flex flex-column mt-3 mb-3 w-100">
          <!-- <p class="mb-1" class="section-title">Tipo vehículo</p>
          <div class="d-flex mb-3" style="gap: 1em;">
              <div class="w-100">
                <input type="text"  class="form-control" placeholder="Clase o nombre de vehículo" formControlName="vehicleType">
              </div>



               <div class="d-flex align-items-center w-100" style="gap: 1em;">
                <label *ngFor="let val of transmissionType" class="form-check-label d-flex align-items-center" style="gap: .5em;">
                  <input
                    type="radio"
                    [value]="val.value"
                    formControlName="transmissionType"
                    class="me-2"
                  />
                  <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;"> {{val.label}}</span>
                </label>
               </div>
          </div> -->
        <div class="d-flex mb-3" style="gap: 1em;">
           <div class="card-option d-flex flex-column" style="width: 25%;">
              <span class="section-title card-label mb-1">Transmisión</span>
             <div *ngFor="let val of transmissionType; let i = index">
                <label class="option-item"
                          [ngStyle]="{'border-bottom': i !== (transmissionType.length - 1) ? '1px solid rgba(229,229,229,0.8)' : ''}">
                  <span class="option-label">{{val.label}}</span>
                   <span class="custom-checkbox">
                     <input
                       type="checkbox"
                       [value]="val.value"
                       [disabled]="edit"
                       (change)="onChangeSelectForm($event,'rent-a-car', 'transmissionType')"
                       [checked]="formRentACar.get('transmissionType').value.includes(val.value)"
                     />
                     <span class="checkbox-visual"></span>
                   </span>
                 </label>
             </div>
            </div>

        <div class="card-option d-flex flex-column" style="width: 75%;">
              <span class="section-title card-label mb-1">Categoría</span>
                <span class="d-flex flex-row flex-wrap w-100" >
                  <div *ngFor="let val of vehicleTypesCar; let i = index" class="pr-3" style=" min-width: 20%;">
                   <label class="option-item"
                    [ngStyle]="{'border-bottom': i < 5 ? '1px solid rgba(229,229,229,0.8)' : ''}">
                      <span class="option-label">{{val.label}}</span>
                        <span class="custom-checkbox">
                          <input
                            type="checkbox"
                            [value]="val.value"
                            [disabled]="edit"
                            (change)="onChangeSelectForm($event,'rent-a-car', 'vehicleType')"
                            [checked]="formRentACar.get('vehicleType').value.includes(val.value)"
                          />
                          <span class="checkbox-visual"></span>
                        </span>
                      </label>
                  </div>
                </span>
            </div>
        </div>
            </div>

          <div class="d-flex flex-column mb-3" >
            <p class="mb-1" class="section-title">Pasajeros</p>
            <div class="d-flex" style="gap: 1em;">
              <div class="w-100 position-relative">
              <input type="number" class="form-control" min="2" id="adults" name="adults" (keypress)="limitNumber($event, 99)" max="99" placeholder="Adultos" (keydown)="blockInvalidKeys($event, 'number')" formControlName="adults">
                 <span *ngIf="
                              formRentACar.get('adults').value === null"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                  <span  *ngIf="formRentACar.get('adults')?.hasError('min')"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Mínimo 1
                   </span>
                   <span *ngIf="formRentACar.get('adults')?.value === 99"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 99
                </span>
              </div>
              <div class="w-100 position-relative">
                <input type="number" min="0" class="form-control" id="childs" name="childs" (keypress)="limitNumber($event, 99)" max="99" (keydown)="blockInvalidKeys($event, 'number')" placeholder="Niños" formControlName="childs">
                <span *ngIf="
                              formRentACar.get('childs').value === null"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                  <span *ngIf="formRentACar.get('childs')?.value === 99"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 99
                </span>
              </div>
              <div class="w-100 position-relative">
                 <input type="text" class="form-control" id="age_childs" name="age_childs" placeholder="Edades de los niños. Ej: 1, 4, 7" (keydown)="blockInvalidKeys($event, 'age_childs')" formControlName="age_childs">
                <span *ngIf="
                              !formRentACar.get('age_childs').valid && formRentACar.get('childs').value > 0"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                    <span *ngIf="
                              formRentACar.get('age_childs').value"
                        class="position-absolute ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px;color: #cbcbcb "
                    >Ej: 1, 4, 7
                   </span>
               </div>
            </div>
          </div>

        <div class="d-flex mt-3 flex-column">
          <span class="section-title">Comentario</span>
          <div class="d-flex flex-column">
            <div class="w-100">
                <textarea name="comment_contact" id="comment_contact" class="form-control comment-textarea" placeholder="Pregunta o comentario" [maxLength]="500" formControlName="comment_contact" rows="5" id=""></textarea>
                <span *ngIf="formRentACar.get('comment_contact').value?.length === 500"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 500 caracteres
                </span>
            </div>
          </div>
         </div>

              <div *ngIf="!edit" class="form-footer">
              <p class="footer-disclaimer mb-0">*Puede completar todos los formularios en una sola solicitud</p>
              <div class="footer-actions">
                <button type="button" class="btn-borrar" (click)="close()">Borrar</button>
                <button type="button" class="btn-enviar" (click)="onSubmit()">Enviar</button>
              </div>
            </div>
      </form>
    </div>
</div>



<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size = "medium" color="#fa1a1a" type="line-scale">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
